// extracted by mini-css-extract-plugin
export default {"zoomModal":"E3-z","image":"F3-z","button":"G3-z","isOverlayShown":"H3-z"};